<template>
  <el-dialog
    title="客户查重"
    :visible.sync="repeatDialogVisible"
    :width="'900px'"
    :close-on-click-modal="false"
    append-to-body
    @close="cancelRepeatDialogVisible"
  >
    <div class="dialog-body addmember-body">
      <el-input
        :placeholder="
          searchType === 'name' ? '请输入客户名称' : '请输入统一社会信用代码'
        "
        v-model="searchTypeValue"
        class="input-with-select"
      >
        <el-select v-model="searchType" slot="prepend">
          <el-option label="客户名称" :value="'name'"></el-option>
          <el-option label="统一社会信用代码" :value="'creditCode'"></el-option>
        </el-select>
        <el-button
          slot="append"
          type="primary"
          style="width: 80px;"
          @click="handleSearch({ pageNumber: 1 })"
          >查重</el-button
        >
      </el-input>
      <el-table
        :data="results"
        ref="table"
        border
        v-loading="loading"
        height="440px"
        style="width: 100%"
      >
        <el-table-column
          width="100"
          prop="name"
          align="center"
          show-overflow-tooltip
          label="客户名称"
        >
        </el-table-column>
        <el-table-column
          prop="gmtCreatedStr"
          align="center"
          show-overflow-tooltip
          label="创建时间"
        >
        </el-table-column>
        <el-table-column
          width="150"
          prop="createName"
          align="center"
          show-overflow-tooltip
          label="创建人"
        >
        </el-table-column>
        <el-table-column
          prop="visitDateStr"
          align="center"
          show-overflow-tooltip
          label="最后拜访时间"
        >
          <template slot-scope="{ row }">
            {{ row.visitDateStr || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          prop="salesmanNames"
          align="center"
          show-overflow-tooltip
          label="业务员"
        >
        </el-table-column>
        <el-table-column
          width="100"
          prop="moduleName"
          align="center"
          show-overflow-tooltip
          label="模块"
        >
        </el-table-column>
        <el-table-column width="100" align="center" label="操作">
          <template slot-scope="{ row }">
            <el-button
              v-if="
                row.moduleName === '客户公海' &&
                  highSeaAuth.highseaApplyCustomer &&
                  highSeaAuth.highseaApplyCustomer.toggleStatus
              "
              :loading="applyCustomerLoading"
              @click="handleApply(row)"
              type="text"
              size="small"
            >
              申请
            </el-button>
            <el-button
              v-if="
                row.moduleName === '客户公海' &&
                  highSeaAuth.allocationCustomer &&
                  highSeaAuth.allocationCustomer.toggleStatus
              "
              @click="handleDistribution(row)"
              type="text"
              size="small"
            >
              分配
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 列表分页 -->
      <div class="pageination">
        <el-pagination
          class="linkman-pagination"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :current-page.sync="page.pageNumber"
          :page-size.sync="page.pageSize"
          :page-sizes="[10]"
          layout="total, sizes, prev, pager, next"
          :total="page.totalCount"
        >
        </el-pagination>
      </div>
      <!-- <p class="tip">注：查重结果最多显示10条，如不完整，请完善查重条件</p> -->
    </div>
  </el-dialog>
</template>
<script>
import customerApi from '@/services/api/customer';
import customRecycleApi from '@/services/api/customRecycle';

import crmButton from '@/components/base/crmButton';
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    show: Boolean,
  },
  data() {
    var validatorName = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入角色名称'));
      } else if (value === ' ') {
        callback(new Error('请输入正确的内容'));
      } else {
        callback();
      }
    };
    return {
      searchTypeValue: '',
      searchType: 'name',
      repeatDialogVisible: false,
      loading: false,
      results: [],
      rules: {
        name: [{ required: true, validator: validatorName, trigger: 'blur' }],
      },
      page: {
        pageNumber: 1,
        pageSize: 10,
        totalCount: null,
      },
      applyCustomerLoading: false,
    };
  },
  components: {
    crmButton,
  },
  computed: {
    ...mapGetters({
      customAuth: 'authority/customAuth',
      highSeaAuth: 'authority/auth',
    }),
  },
  watch: {
    repeatDialogVisible() {
      this.$emit('update:show', this.repeatDialogVisible);
    },
  },
  async mounted() {
    this.repeatDialogVisible = this.show;
    await this.getAuthority({ menuUrl: '/cusRecycle' });
    this.handleSearch({ pageNumber: 1 });
  },
  methods: {
    ...mapActions({
      getAuthority: 'authority/getAuthority',
      getCustomType: 'common/getCustomType',
    }),
    handleSearch(page) {
      if (page) this.page.pageNumber = page?.pageNumber;
      customerApi
        .searchCustomerRepeat({
          name: this.searchType === 'name' ? this.searchTypeValue : '',
          creditCode: this.searchType !== 'name' ? this.searchTypeValue : '',
          pageNumber: (page && page.pageNumber) || this.page.pageNumber,
          pageSize: this.page.pageSize,
        })
        .then((res) => {
          this.results = res.data.results || [];
          this.page = res.data;
        });
    },
    cancelRepeatDialogVisible() {
      this.$emit('update:show', false);
      this.$emit('close');
    },
    handleDistribution(row) {
      this.cancelRepeatDialogVisible();
      this.$parent.$refs.dialogDistribution.dialogVisible = true;
      this.$parent.$refs.dialogDistribution.form.ids = [row.id];
    },
    handleApply(row) {
      this.applyCustomerLoading = true;
      customRecycleApi
        .applyCustomer({
          ids: [row.id],
        })
        .then((res) => {
          // const statusTip = {
          //   0: '全部申请成功!',
          //   1: '部分申请成功!',
          //   2: '申请失败!',
          // };
          this.$message({
            message: res.data.data,
            // message: statusTip[res.data.data],
            // type: res.data.data === 2 ? 'error' : 'success',
          });
          this.handleSearch();
        })
        .finally(() => {
          this.applyCustomerLoading = false;
        });
    },
    handleSizeChange(size) {
      this.page.pageSize = size;
      this.page.pageNumber = 1;
      this.handleSearch();
    },
    handlePageChange(index) {
      this.page.pageNumber = index;
      this.handleSearch();
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-input-group__prepend {
  width: 150px !important;
}
/deep/ .el-input__inner {
  padding-right: 50px;
}
/deep/ .el-textarea__inner::-webkit-input-placeholder {
  font-size: 12px;
}
/deep/ .el-textarea__inner::-moz-input-placeholder {
  font-size: 12px;
}
/deep/ .el-textarea__inner::-ms-input-placeholder {
  font-size: 12px;
}
/deep/ .el-form-item {
  margin-bottom: 0;
}
/deep/ .el-textarea__inner {
  max-height: 100px;
}
/deep/ .el-input-group__append,
.el-input-group__prepend {
  background-color: rgb(67, 96, 255);
  color: #fff;
}
.input-with-select {
  margin-bottom: 10px;
}
p.tip {
  margin: 20px 0;
  font-size: 12px;
  color: #7a84b7;
}
</style>
